import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';

interface NumberCardProps {
  number: number;
  onSelect: () => void;
  disabled?: boolean;
}

export default function NumberCard({ number, onSelect, disabled }: NumberCardProps) {
  return (
    <motion.div
      whileHover={!disabled ? { scale: 1.05 } : {}}
      whileTap={!disabled ? { scale: 0.95 } : {}}
      className="w-full"
    >
      <Button
        onClick={onSelect}
        disabled={disabled}
        className="
          w-full h-64 md:h-80
          glass-card
          border-4 border-border/30
          hover:border-primary/60
          disabled:opacity-50
          disabled:cursor-not-allowed
          flex items-center justify-center
          text-8xl md:text-9xl font-black
          text-shadow
          transition-all duration-200
          hover:glow-green
          pointer-events-auto
          cursor-pointer
        "
        variant="secondary"
      >
        {number}
      </Button>
    </motion.div>
  );
}
